'use strict';

angular.module('studies')
    .factory('StudiesManager', ['$q', 'ShareCrfSDK', 'Event', function($q, ShareCrfSDK, Event) {
        var initied = false;
        var loadPromise = null;

        var serviceData = {
            // Data from API portal
            userStudies: [],
            // Data from API study
            studyData: {},
        };

        var StudiesManager = {};

        /**
         * Init
         *
         * @return {Promise}
         */
        StudiesManager.init = function StudiesManagerInit() {
            var promise;

            if (initied) {
                promise = $q.resolve();
            }
            else if (loadPromise) {
                promise = loadPromise;
            }
            else {
                loadPromise = StudiesManager.loadUserStudies()
                    .then(function(response) {
                        Array.prototype.push.apply(serviceData.userStudies, response.data);
                        initied = true;

                        loadPromise = null;
                    });

                promise = loadPromise;
            }

            return promise;
        };

        StudiesManager.reload = function StudiesManagerReload() {
            var promise;

            if (!initied) {
                promise = StudiesManager.init();
            }
            else if (loadPromise) {
                promise = loadPromise;
            }
            else {
                loadPromise = StudiesManager.loadUserStudies()
                    .then(function(response) {
                        _.remove(serviceData.userStudies);
                        Array.prototype.push.apply(serviceData.userStudies, response.data);

                        loadPromise = null;
                    });

                promise = loadPromise;
            }

            return promise;
        };

        /**
         * Get list
         *
         * @return {Array}
         */
        StudiesManager.getUserStudies = function StudiesManagerGetUserStudies() {
            return serviceData.userStudies;
        };

        /**
         * Get user data in study
         *
         * The first time this method is invoked, data is loaded from server (API study)
         *
         * @param {String}  studyDomain
         * @param {Boolean} force
         *
         * @return {Promise<Object>}
         */
        StudiesManager.getUserDataInStudy = function StudiesManagerGetUserDataInStudy(studyDomain, force) {
            var promise = $q.resolve();

            if (!serviceData.studyData[studyDomain] || force) {
                promise = promise
                    .then(function() {
                        return ShareCrfSDK.portal.getUserInStudy(studyDomain);
                    })
                    .then(function(userData) {
                        serviceData.studyData[studyDomain] = userData;
                    });
            }

            return promise
                .then(function() {
                    return serviceData.studyData[studyDomain];
                });
        };

        StudiesManager.getStudyInfo = function StudiesManagerGetStudyInfo(studySubdomain) {
            return ShareCrfSDK.portal.studies.getInfo(studySubdomain);
        };

        /**
         * Clear data
         *
         * Registered in event 'logout'
         */
        StudiesManager.clearData = function StudiesManagerClearData() {
            initied = false;
            _.remove(serviceData.userStudies);
            serviceData.studyData = {};
        };

        /**
         * Load user studies
         *
         * Get studies data from server (API portal)
         * Registered in event 'invitation_accepted'
         *
         * @return {Promise<Array>}
         */
        StudiesManager.loadUserStudies = function StudiesManagerLoadUserStudies() {
            var options = {
                expand: 'creator($select=id)',
                order: 'subdomain asc',
            };

            return ShareCrfSDK.portal.studies.getLoggedUserStudies(options);
        };

        /**
         * Count user created studies
         *
         * @param {Integer} userId
         *
         * @return {Integer}
         */
        StudiesManager.countUserCreatedStudies = function StudiesManagerCountUserCreatedStudies(userId) {
            return serviceData.userStudies.filter(function(study) {
                return study.creator.id == userId;
            }).length;
        };

        /**
         * Create study
         *
         * @param {Object} studyData
         *
         * @return {Promise}
         */
        StudiesManager.create = function StudiesManagerCreate(studyData) {
            return ShareCrfSDK.portal.studies.create(studyData)
                .then(function(createdStudy) {
                    serviceData.userStudies.push(createdStudy);

                    // Trigger event
                    Event.trigger('studyCreated');
                });
        };

        StudiesManager.update = function StudiesManagerUpdate(studySubdomain, studyData) {
            return ShareCrfSDK.portal.studies.update(studySubdomain, studyData)
                .then(function() {
                    delete serviceData.studyData[studySubdomain];
                });
        }

        /**
         * Event listeners
         */
        Event.on('logout', StudiesManager.clearData);
        Event.on('invitationAccepted', StudiesManager.reload);

        return StudiesManager;
    }]);
